import { Box, type BoxProps } from '@mui/material'
import logoFiesta from '../assets/logo-fiesta.png'

type FiestaBrandLogoProps = {
  /** Altura em px (largura automática). */
  height?: number
  alt?: string
} & Omit<BoxProps, 'component' | 'children'>

/**
 * Logo horizontal Fiesta Party Festa (PNG transparente a partir do PDF principal).
 */
export function FiestaBrandLogo({
  height = 40,
  alt = 'Fiesta Party Festa',
  sx,
  ...rest
}: FiestaBrandLogoProps) {
  return (
    <Box
      {...rest}
      component="img"
      src={logoFiesta}
      alt={alt}
      sx={{
        height,
        width: 'auto',
        maxWidth: '100%',
        display: 'block',
        objectFit: 'contain',
        flexShrink: 0,
        lineHeight: 0,
        ...sx,
      }}
    />
  )
}
